import { Injectable } from '@angular/core';
import { Config } from '../config/config';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(
    private httpClient: HttpClient
  ) { }

  create(data): Observable<any> {
    return this.httpClient.post(Config.api + Config.endpoints.createCompany, data);
  }
  update(data, uuid): Observable<any> {
    return this.httpClient.put(Config.api + Config.endpoints.companies + `/${uuid}`, data);
  }

}
